/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RedeemResponseBody = {
  /**
   * The raw gram_ API key, carrying the [agent,hooks] scopes. Returned exactly once.
   */
  accessToken: string;
  /**
   * Slug of the project the key is scoped to.
   */
  projectSlug: string;
  /**
   * Email of the user the key was minted for.
   */
  userEmail: string;
};

/** @internal */
export const RedeemResponseBody$inboundSchema: z.ZodMiniType<
  RedeemResponseBody,
  unknown
> = z.pipe(
  z.object({
    access_token: z.string(),
    project_slug: z.string(),
    user_email: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "access_token": "accessToken",
      "project_slug": "projectSlug",
      "user_email": "userEmail",
    });
  }),
);

export function redeemResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<RedeemResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RedeemResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RedeemResponseBody' from JSON`,
  );
}
